import classNames from 'classnames';

// Renders build-time-compiled Markdown HTML, styled to the design system via
// descendant utilities (no typography plugin). Shared by legal docs and blog
// posts so Markdown renders identically everywhere. Blockquotes become a soft
// brand callout.
export const Prose = ({
  html,
  className,
}: {
  html: string;
  className?: string;
}) => (
  <article
    className={classNames(styles, className)}
    dangerouslySetInnerHTML={{ __html: html }}
  />
);

const styles = classNames(
  'text-[16px] leading-7 text-mf-gray-600',
  '[&_h2]:mt-12 [&_h2]:mb-4 [&_h2]:font-inter [&_h2]:text-[24px] [&_h2]:font-bold [&_h2]:tracking-[-0.01em] [&_h2]:text-mf-off-black-950 [&_h2]:scroll-mt-24',
  '[&_h2:first-child]:mt-0',
  '[&_h3]:mb-3 [&_h3]:mt-8 [&_h3]:text-lg [&_h3]:font-bold [&_h3]:text-mf-off-black-950',
  '[&_p]:mb-4',
  '[&_a]:font-medium [&_a]:text-mf-blue [&_a]:underline [&_a]:decoration-mf-blue/30 [&_a]:underline-offset-2 hover:[&_a]:decoration-mf-blue',
  '[&_ul]:mb-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:mb-4 [&_ol]:list-decimal [&_ol]:pl-6 [&_li]:mb-1.5 [&_ul_ul]:mt-1.5 [&_ul_ul]:mb-0',
  '[&_strong]:font-semibold [&_strong]:text-mf-off-black-900',
  '[&_blockquote]:my-6 [&_blockquote]:rounded-2xl [&_blockquote]:border [&_blockquote]:border-mf-blue-200 [&_blockquote]:bg-mf-blue-50 [&_blockquote]:px-5 [&_blockquote]:py-4 [&_blockquote]:text-mf-off-black-800 [&_blockquote_p]:mb-0',
);
